import { useSelector } from 'react-redux'

// Rótulo do dicionário da API (GET /dictionary), no idioma do tenant. Enquanto o
// dicionário não chega, ou se a chamada falhar, usa o texto passado como fallback
export const useLabel = () => {
  const dictionary = useSelector(state => state.auth.dictionary)
  return (key, fallback) => dictionary?.[key] ?? fallback
}
